/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_BackInputs */



/**
* | output |
* | --- |
* | "Back" |
*
* @param {Subtitle_Extract_BackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_back = /** @type {((inputs?: Subtitle_Extract_BackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_BackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dos")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indietro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назад")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atrás")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("后退")
	if (locale === "ja") return /** @type {LocalizedString} */ ("戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पीछे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voltar")
	return /** @type {LocalizedString} */ ("Back")
});